module.exports = __webpack_public_path__ + "static/dietary_fiber-1d5090add5c84b13477999b23b631556.png";